import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-gps-off",
  templateUrl: "./med-icon-gps-off.component.html",
})
export class MedIconGpsOffComponent extends SvgMixinComponent {}
